import { Unauthorized } from "@app/shared/ErrorPages";
import { JSX, useContext } from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { UserContext } from "@app/user/UserContext";
import Roles from "@app/user/roles";
import ResourceTagViewer from "@app/tags/ResourceTagViewer";
import { UploadTagsWizard } from "@app/tags/import";

const TagsRouter = (props: RouteComponentProps): JSX.Element => {
  const userContext = useContext(UserContext);
  if (!userContext.roles.includes(Roles.CLIENT_ADMIN)) {
    return <Unauthorized />;
  }
  return (
    <Switch>
      <Route path={`${props.match.path}/view`} component={ResourceTagViewer} />
      <Route path={`${props.match.path}/import`} component={UploadTagsWizard} />
    </Switch>
  );
};

export default TagsRouter;
